// extracted by mini-css-extract-plugin
export default {"container":"Brands_container__4x5uH","title":"Brands_title__v9nak","items":"Brands_items__JLSG3"};